import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormManager, FormRow, Grid, PageTitle, useCacheQuery } from 'gossamer-front-end';
import { InstitutionGroup, InstitutionGroupAttachment, InstitutionGroupAttachmentRow } from 'cb-model';
import { getFilter, getListRowLink } from 'gossamer-unified';

export const AttachmentsGrid = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const query = useCacheQuery(InstitutionGroupAttachment, {
    where: { and: [getFilter('institution_group_id', 'eq', params.key)] },
  });
  const handleExit = () => navigate(getListRowLink(InstitutionGroup.listRowLink, params.key));
  return (
    <>
      <PageTitle verb="Update" entity={InstitutionGroupAttachment} />
      <FormManager
        compoundUrl="/main/~/institution-group-attachments-grid"
        handleCancel={handleExit}
        handleSuccess={handleExit}
        initialization={{
          main: {
            type: 'update-multi',
            entity: InstitutionGroupAttachment,
            query,
          },
        }}
      >
        <Grid
          valuesKey="main"
          entity={InstitutionGroupAttachment}
          onAddRow={(data: FormRow<InstitutionGroupAttachmentRow>, newValue: string) => {
            data.institution_group_id = parseInt(params.key);
          }}
        />
      </FormManager>
    </>
  );
};
